/**
 * Build a minimal GPX 1.1 document for a single track.
 *
 * coords are [lng, lat] pairs (the same shape Route.geometry() produces).
 * GPX expects lat/lon attributes, so we swap on the way out.
 *
 * The <metadata> block carries an OSM/ODbL <copyright> element so the
 * exported file documents its data lineage and license. Required by
 * OSM's attribution guidelines for any redistributed derivative.
 */
export function toGPX(name: string, coords: Array<[number, number]>): string {
  const safeName = xmlEscape(name.trim() || 'afveje rute');
  const trkpts = coords
    .map(([lng, lat]) => `      <trkpt lat="${lat}" lon="${lng}"></trkpt>`)
    .join('\n');
  const now = new Date();
  const stamp = now.toISOString();
  const year = now.getUTCFullYear();
  return `<?xml version="1.0" encoding="UTF-8"?>
<gpx version="1.1" creator="afveje.dk" xmlns="http://www.topografix.com/GPX/1/1">
  <metadata>
    <name>${safeName}</name>
    <desc>Rute genereret med afveje.dk. Kortdata fra OpenStreetMap-bidragyderne, ODbL.</desc>
    <author>
      <name>afveje.dk</name>
      <link href="https://afveje.dk/"><text>afveje.dk</text></link>
    </author>
    <copyright author="OpenStreetMap contributors">
      <year>${year}</year>
      <license>https://opendatacommons.org/licenses/odbl/1-0/</license>
    </copyright>
    <link href="https://afveje.dk/credits/"><text>Kreditering</text></link>
    <time>${stamp}</time>
  </metadata>
  <trk>
    <name>${safeName}</name>
    <trkseg>
${trkpts}
    </trkseg>
  </trk>
</gpx>
`;
}

function xmlEscape(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}
